module.exports = __webpack_public_path__ + "static/Octicons-8e7f807ef943bff1f6d3c2c6e0f3769e.ttf";